module.exports = __webpack_public_path__ + "media/images/deliver-icon-display-ee3083082c0ea8f0e63dc6eb53e0133f.svg";